module.exports = __webpack_public_path__ + "static/media/chess.3e099d0b.jpg";